import React from "react";
import GestorThemeDrawer from "./Drawers/GestorThemeDrawer";
import OpenDeliveryDrawer from "./Drawers/OpenDeliveryDrawer";
import KMLDeliveryDrawer from "./Drawers/KMLDeliveryDrawer";
import HoldingBannersDrawer from "./Drawers/HoldingBannersDrawer";
import BrandBannerTotem from "./Drawers/BrandBannerTotemDrawer";
import GestorSeo from "./Drawers/GestorSeo";
import OpenDeliveryRefreshDrawer from "./Drawers/OpenDeliveryRefreshDrawer";
import { OlgaHoldingDrawer } from "./Drawers/OlgaHoldingDrawer";
import CashbackConfigurations from "./Drawers/CashbackConfigurations";
import ExtraMenusDrawer from "./Drawers/ExtraMenusDrawer";
import { AppLinksHoldingDrawer } from "./Drawers/AppLinksHoldingDrawer";
import { AppLinksBrandDrawer } from "./Drawers/AppLinksBrandDrawer";
import AddressPreferencesDrawer from "./Drawers/AddressPreferencesDrawer";
import AutoCancelOpened from "./Drawers/AutoCancelOpened";
import ResetPassword from "./Drawers/ResetPassword";
import CustomerPermissionsDrawer from "./Drawers/CustomerPermissionsDrawer";
import HoldingLogoDrawer from "./Drawers/HoldingLogoDrawer";
import CustomerAttributesDrawer from "./Drawers/CustomerAttributesDrawer";

export const SecretDrawerTypes = {
  GESTOR_THEME: "GESTOR_THEME",
  GESTOR_SEO: "GESTOR_SEO",
  OPEN_DELIVERY: "OPEN_DELIVERY",
  REFRESH_OPEN_DELIVERY: "REFRESH_OPEN_DELIVERY",
  KML_DELIVERY: "KML_DELIVERY",
  HOLDING_BANNER: "HOLDING_BANNER",
  BRAND_BANNER_TOTEM: "BRAND_BANNER_TOTEM",
  HOLDING_OLGA: "HOLDING_OLGA",
  CASHBACK_CONFIGURATION: "CASHBACK_CONFIGURATION",
  EXTRA_MENUS: "EXTRA_MENUS",
  APP_LINKS_HOLDING: "APP_LINKS_HOLDING",
  APP_LINKS_BRAND: "APP_LINKS_BRAND",
  ADDRESS_PREFERENCES: "ADDRESS_PREFERENCES",
  AUTO_CANCEL_OPENED: "AUTO_CANCEL_OPENED",
  RESET_PASSWORD: "RESET_PASSWORD",
  BRAND_LOGO: "BRAND_LOGO",
  CUSTOMER_ATTRIBUTES: "CUSTOMER_ATTRIBUTES",
};

export class SecretSettingDrawer extends React.Component {
  state = {
    data: null,
  };

  onClose() {
    const { onClose } = this.props;
    this.setState({ data: null }, onClose);
  }

  render() {
    const { visible, setting, onSave, onClose } = this.props;

    switch (setting) {
      case SecretDrawerTypes.GESTOR_THEME:
        return (
          <GestorThemeDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.OPEN_DELIVERY:
        return (
          <OpenDeliveryDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.REFRESH_OPEN_DELIVERY:
        return (
          <OpenDeliveryRefreshDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
            refresh={true}
          />
        );
      case SecretDrawerTypes.KML_DELIVERY:
        return (
          <KMLDeliveryDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.HOLDING_BANNER:
        return (
          <HoldingBannersDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.BRAND_BANNER_TOTEM:
        return (
          <BrandBannerTotem
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.HOLDING_OLGA:
        return (
          <OlgaHoldingDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.GESTOR_SEO:
        return (
          <GestorSeo visible={visible} onSave={onSave} onClose={onClose} />
        );
      case SecretDrawerTypes.CASHBACK_CONFIGURATION:
        return (
          <CashbackConfigurations
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.EXTRA_MENUS:
        return (
          <ExtraMenusDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.APP_LINKS_HOLDING:
        return (
          <AppLinksHoldingDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.APP_LINKS_BRAND:
        return (
          <AppLinksBrandDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );

      case SecretDrawerTypes.ADDRESS_PREFERENCES:
        return (
          <AddressPreferencesDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.AUTO_CANCEL_OPENED:
        return (
          <AutoCancelOpened
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.BRAND_LOGO:
        return (
          <HoldingLogoDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SecretDrawerTypes.CUSTOMER_ATTRIBUTES:
        return (
          <CustomerAttributesDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  }
}
